<template>
    <div :class="errors[0] ? 'mb-1' : 'mb-4'">
        <FieldLabel
            v-if="label"
            :tooltip="tooltip"
            :required="required"
            :name="name"
        >
            {{ label }}
        </FieldLabel>
        <slot />
        <FieldErrors
            v-if="errors.length > 0"
            :errors="errors"
        />
    </div>
</template>

<script>
import FieldErrors from './FieldErrors.vue';
import FieldLabel from './FieldLabel.vue';
import fieldPropsMixin from '@/mixins/fieldPropsMixin';

export default {
    components: {
        FieldLabel,
        FieldErrors,
    },
    mixins: [fieldPropsMixin],
};
</script>

<style></style>
